import React, { useCallback, useMemo, useState, useEffect, } from 'react';
import { Colors, } from 'assets/index';

export const RequiredLabel = ({ children }) => <>{children} <span style={{ color: Colors.redRemove }}>*</span></>;